export default "/images/safesecure.png?eff543286fd7ed3a13be8fffd1d5f9f5";